import { StringToBool } from "../utils/StringToBool";
import { QXMLObject } from "./QXMLObject";

export class QMultiDocParams extends QXMLObject {
  constructor() {
    super();
    this.fCompoundDoc = false;
    this.fCompoundFilterID = "";
    this.fAltFilterID = "";
    this.fChainLevels = 0;
    this.fAddExec = true;
    this.fFixHierarchy = true;
    this.fCurrentDiv = null;

    this.fv2PreProcessor = false; //Handle assuming data is in the format of the preprocessor and to check for dupes appropriately
    this.fdoSubDivide = false;

    this.SetXMLElementName("multidoc");
  }

  InitMultiDocParams(isCompoundDoc, filterID, altFilterID, chainLevels, addExec, fixHierarchy) {
    this.fCompoundDoc = isCompoundDoc;
    this.fCompoundFilterID = filterID;
    this.fAltFilterID = altFilterID;

    this.fChainLevels = chainLevels;
    this.fAddExec = addExec;
    this.fFixHierarchy = fixHierarchy;

    // this.SetXMLElementName("multidoc");
  }

  LoadSubElements(objTree) {
    var compoundDoc = objTree.GetValueForChild("compounddoc", false);
    this.fCompoundDoc = StringToBool(compoundDoc);
    this.fCompoundFilterID = objTree.GetValueForChild("filterid", false);
    this.fAltFilterID = objTree.GetValueForChild("altid", false);

    this.fChainLevels = objTree.GetValueForChild("chain", true);

    var addExec = objTree.GetValueForChild("addexec", false);
    this.fAddExec = StringToBool(addExec);
    var fixHier = objTree.GetValueForChild("autofixhier", false);
    this.fFixHierarchy = StringToBool(fixHier);

    var currentDiv = objTree.GetValueForChild("currentdiv", false);
    if (currentDiv) this.fCurrentDiv = currentDiv;
  }

  OutputSubElements(stream) {
    this.OutputSimpleElement("compounddoc", this.fCompoundDoc, stream);
    this.OutputSimpleElement("filterid", this.fCompoundFilterID, stream);
    this.OutputSimpleElement("altid", this.fAltFilterID, stream);

    this.OutputSimpleElement("chain", this.fChainLevels, stream);
    this.OutputSimpleElement("addexec", this.fAddExec, stream);
    this.OutputSimpleElement("autofixhier", this.fFixHierarchy, stream);

    if (this.fCurrentDiv) this.OutputSimpleElement("currentdiv", this.fCurrentDiv, stream);
  }

  LoadFromJSON(json) {
    //TODO: Sanitize this on saving.
    this.fCompoundDoc = json["compounddoc"];
    this.fCompoundFilterID = json["filterid"];
    this.fAltFilterID = json["altid"];

    this.fChainLevels = json["chain"];
    this.fAddExec = json["addexec"];
    this.fFixHierarchy = json["autofixhier"];

    if (json["currentdiv"]) this.fCurrentDiv = json["currentdiv"];
  }

  OutputToJSON(json) {
    //TODO: Sanitize this on saving.
    var multiObj = {};
    multiObj["compounddoc"] = this.fCompoundDoc;
    multiObj["filterid"] = this.fCompoundFilterID;
    multiObj["altid"] = this.fAltFilterID;

    multiObj["chain"] = this.fChainLevels;
    multiObj["addexec"] = this.fAddExec;
    multiObj["autofixhier"] = this.fFixHierarchy;

    if (this.fCurrentDiv) multiObj["currentdiv"] = this.fCurrentDiv;

    json["multiParams"] = multiObj;
  }

  SetCurrentDiv(divName) {
    this.fCurrentDiv = divName;
  }

  GetCurrentDiv() {
    return this.fCurrentDiv;
  }

  SetCompoundDoc(compoundDoc) {
    this.fCompoundDoc = compoundDoc;
  }

  GetCompoundDoc() {
    return this.fCompoundDoc;
  }

  SetCompoundFilterID(filterID) {
    this.fCompoundFilterID = filterID;
  }

  GetCompoundFilterID() {
    return this.fCompoundFilterID;
  }

  SetAltFilterID(filterID) {
    this.fAltFilterID = filterID;
  }

  GetAltFilterID() {
    return this.fAltFilterID;
  }

  SetChain(chainLevels) {
    this.fChainLevels = chainLevels;
  }

  GetChain() {
    return this.fChainLevels;
  }

  SetAddExec(addExec) {
    this.fAddExec = addExec;
  }

  GetAddExec() {
    return this.fAddExec;
  }

  SetAutoFixHierarchy(autoFix) {
    this.fFixHierarchy = autoFix;
  }

  GetAutoFixHierarchy() {
    return this.fFixHierarchy;
  }

  Clone() {
    var c = new QMultiDocParams();
    c.InitMultiDocParams(
      this.fCompoundDoc,
      this.fCompoundFilterID,
      this.fAltFilterID,
      this.fChainLevels,
      this.fAddExec,
      this.fFixHierarchy
    );
    return c;
  }
}
